"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceDateFilter = void 0;
exports.InvoiceDateFilter = {
    InvoiceDate: "INVOICE_DATE",
    DeductionDate: "DEDUCTION_DATE",
    DueDate: "DUE_DATE",
    SettlementDate: "SETTLEMENT_DATE",
    CreatedAt: "CREATED_AT",
    UpdatedAt: "UPDATED_AT",
};
